import eventEmitter from '../eventEmitter';
import NotificationEvent from './NotificationEvent';
import NotificationType from './NotificationType';

export default {
  addPopup: (notification) => {
    eventEmitter.emit(NotificationEvent.ADD_NOTIFICATION, { type: NotificationType.POPUP , data: notification });
  },
  removePopup: () => {
    eventEmitter.emit(NotificationEvent.REMOVE_NOTIFICATION, { type: NotificationType.POPUP });
  },
  addAlert: (alert) => {
    eventEmitter.emit(NotificationEvent.ADD_NOTIFICATION, { type: NotificationType.ALERT, data: alert })
  },
  removeAlert: () => {
    eventEmitter.emit(NotificationEvent.REMOVE_NOTIFICATION, { type: NotificationType.ALERT });
  }
}
